<template>
    <div>
        <ValidationObserver tag="form" ref="observer" @submit.prevent="onSubmit">

            <FormInput label="Valoración Técnica:" name="Val.Técnica" type="number" id="tecnica" v-model="form.tecnica"
                placeholder="Del 0 a 10" rules="required|numeric|max_value:10|min_value:0"></FormInput>

            <FormInput label="Valoración Táctica:" name="Val.Táctica" type="number" id="tactica" v-model="form.tactica"
                placeholder="Del 0 a 10" rules="required|numeric|max_value:10|min_value:0"></FormInput>

            <FormInput label="Capacidad Física:" name="Cap.Física" type="number" id="fisica" v-model="form.fisica"
                placeholder="Del 0 a 10" rules="required|numeric|max_value:10|min_value:0"></FormInput>

            <FormInput label="Psicológica:" name="Psicológica" type="number" id="psicologica" v-model="form.psicologica"
                placeholder="Del 0 a 10" rules="required|numeric|max_value:10|min_value:0"></FormInput>

            <FormInput label="Personalidad:" name="Personalidad" type="number" id="personalidad" v-model="form.personalidad"
                placeholder="Del 0 a 10" rules="required|numeric|max_value:10|min_value:0"></FormInput>

            <div class="d-flex justify-content-between">
                <Button @click="$bvModal.hide('modalForm')" class="bg-danger">cancelar</Button>
                <Button type="submit" class="bg-primary">Guardar</Button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
export default {
    props: ['base_id', 'valoracion'],
    data() {
        return {
            form: {
                base_id: this.base_id,
                tecnica: '',
                tactica: '',
                fisica: '',
                psicologica: '',
                personalidad: '',
            }
        }
    },
    created() {
        if (this.valoracion) {
            this.form.tecnica = this.valoracion.tecnica;
            this.form.tactica = this.valoracion.tactica;
            this.form.fisica = this.valoracion.fisica;
            this.form.psicologica = this.valoracion.psicologica;
            this.form.personalidad = this.valoracion.personalidad;
        }
    },
    methods: {
        async onSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.form.filters = {};
                this.form.valoracion_id = this.valoracion ? this.valoracion.id : 0;

                this.$store.dispatch(this.config.getVuexAlias(this.valoracion ? 'back.bases.valoraciones.update' : 'back.bases.valoraciones.crear'), this.form).then(() => {
                    this.$toast.success('Valoración editada correctamente.');
                    this.$bvModal.hide('modalForm');
                    this.$emit('edit');
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error.');
                });
            }

        }
    }
}
</script>